export default __webpack_public_path__ + "static/media/Bossa-ExpandedBold.47751d60.woff";